const _import = require('@/router/_import_' + process.env.NODE_ENV)
import Layout from '@/views/layout/Layout'

export const initRouterMap = [
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'noredirect',
    hidden: true,
    children: [
      {
        path: '',
        component: _import('home/index'),
        name: 'Home',
        meta: {
          title: 'home',
          icon: 'home'
        }
      }
    ]
  },
  {
    path: '/register',
    component: _import('register/index'),
    hidden: true
  },
  {
    path: '/forgot-password',
    component: _import('forgot-password/index'),
    hidden: true
  },
  {
    path: '/open-shop',
    component: _import('open-shop/index'),
    hidden: true
  },
  {
    path: '/open-shop-settle/:id',
    name: 'OpenShopSettle',
    component: _import('open-shop/settle'),
    hidden: true
  },
  // {
  //   path: '/verify-successfully',
  //   component: _import('register/VerifySuccessfully'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: _import('404'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

// export const transactionsRoutes = [
//   {
//     path: '/transactions',
//     component: Layout,
//     redirect: 'noredirect',
//     name: 'Transactions',
//     meta: {
//       title: 'transactionCenter',
//       icon: 'merchandise'
//     },
//     children: [
//       {
//         path: 'list',
//         component: _import('transactions/index'),
//         name: 'TransactionCenter',
//         meta: {
//           title: 'transactionCenter',
//           icon: 'merchandise',
//           keepAlive: true
//         }
//       }
//     ]
//   }
// ]

export const constantRouterMap = [
  // 订单中心
  {
    path: '/order',
    component: Layout,
    redirect: 'noredirect',
    name: 'Order',
    meta: {
      title: 'orderCenter',
      icon: 'order'
    },
    children: [
      {
        path: 'all',
        component: _import('order/all'),
        name: 'All',
        meta: {
          title: 'allOrders',
          icon: 'order',
          keepAlive: true
        }
      }
      // {
      //   path: 'unpaid',
      //   component: _import('order/unpaid'),
      //   name: 'Unpaid',
      //   meta: {
      //     title: 'unpaidOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'partUnpaid',
      //   component: _import('order/partUnpaid'),
      //   name: 'PartUnpaid',
      //   meta: {
      //     title: 'partUnpaidOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'paid',
      //   component: _import('order/paid'),
      //   name: 'Paid',
      //   meta: {
      //     title: 'paidOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'picking',
      //   component: _import('order/picking'),
      //   name: 'Picking',
      //   meta: {
      //     title: 'pickingOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'shipped',
      //   component: _import('order/shipped'),
      //   name: 'Shipped',
      //   meta: {
      //     title: 'shippedOrders',
      //     keepAlive: true
      //   }
      // },
      // // {
      // //   path: 'unpaid_shipped',
      // //   component: _import('order/unpaidShipped'),
      // //   name: 'UnpaidShipped',
      // //   meta: {
      // //     title: 'unpaidShippedOrders'
      // //   }
      // // },
      // {
      //   path: 'request_refund',
      //   component: _import('order/requestRefund'),
      //   name: 'RequestRefund',
      //   meta: {
      //     title: 'requestRefundOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'refund_finished',
      //   component: _import('order/refundFinished'),
      //   name: 'RefundFinished',
      //   meta: {
      //     title: 'refundFinishedOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'completed',
      //   component: _import('order/completed'),
      //   name: 'Completed',
      //   meta: {
      //     title: 'completedOrders',
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'closed',
      //   component: _import('order/closed'),
      //   name: 'Closed',
      //   meta: {
      //     title: 'closedOrders',
      //     keepAlive: true
      //   }
      // }
    ]
  },
  {
    path: '/order/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':orderId',
        name: 'OrderEdit',
        component: _import('order/edit'),
        meta: {
          title: 'orderEdit'
        }
      }
    ]
  },
  {
    path: '/order/view',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':orderId',
        name: 'OrderView',
        component: _import('order/view'),
        meta: {
          title: 'orderView'
        }
      }
    ]
  },

  // 商品中心
  {
    path: '/merchandise',
    component: Layout,
    redirect: 'noredirect',
    name: 'Merchandise',
    meta: {
      title: 'merchandiseCenter',
      icon: 'merchandise'
    },
    children: [
      {
        path: 'brand',
        component: _import('merchandise/brand'),
        name: 'Brand',
        meta: {
          title: 'brand',
          keepAlive: true
        }
      },
      {
        path: 'categories',
        component: _import('merchandise/categories'),
        name: 'Categories',
        meta: {
          title: 'categories',
          keepAlive: true
        }
      },
      {
        path: 'warehouse',
        component: _import('merchandise/warehouse'),
        name: 'Warehouse',
        meta: {
          title: 'warehouse',
          keepAlive: true
        }
      },
      {
        path: 'management',
        component: _import('merchandise/management'),
        name: 'Management',
        meta: {
          title: 'management',
          keepAlive: true
        }
      },
      {
        path: 'goods-management',
        component: _import('shop/components/GoodsManagement'),
        name: 'GoodsManagement',
        meta: {
          title: 'goodsManagement'
        }
      }
    ]
  },

  // 商品品牌
  {
    path: '/merchandise/brand/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateBrand',
        component: _import('merchandise/brand/create'),
        meta: {
          title: 'createBrand'
        }
      }
    ]
  },
  {
    path: '/merchandise/brand/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':brandId',
        name: 'EditBrand',
        component: _import('merchandise/brand/edit'),
        meta: {
          title: 'editBrand'
        }
      }
    ]
  },
  {
    path: '/merchandise/brand/view',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':brandId',
        name: 'ViewBrand',
        component: _import('merchandise/brand/view'),
        meta: {
          title: 'viewBrand'
        }
      }
    ]
  },

  // 商品分类
  {
    path: '/merchandise/categories/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateCategories',
        component: _import('merchandise/categories/create'),
        meta: {
          title: 'createCategories'
        }
      }
    ]
  },
  {
    path: '/merchandise/categories/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':categoryId',
        name: 'EditCategories',
        component: _import('merchandise/categories/edit'),
        meta: {
          title: 'editCategories'
        }
      }
    ]
  },

  // 发货仓管理
  {
    path: '/merchandise/warehouse/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateWarehouse',
        component: _import('merchandise/warehouse/create'),
        meta: {
          title: 'createWarehouse'
        }
      }
    ]
  },
  {
    path: '/merchandise/warehouse/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':warehouseId',
        name: 'EditWarehouse',
        component: _import('merchandise/warehouse/edit'),
        meta: {
          title: 'editWarehouse'
        }
      }
    ]
  },

  // 商品管理
  {
    path: '/merchandise/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateMerchandise',
        component: _import('merchandise/merchandise/create'),
        meta: {
          title: 'createMerchandise'
        }
      }
    ]
  },
  {
    path: '/merchandise/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':goodsId',
        name: 'EditMerchandise',
        component: _import('merchandise/merchandise/edit'),
        meta: {
          title: 'editMerchandise'
        }
      }
    ]
  },

  // 统计中心
  {
    path: '/statistics',
    component: Layout,
    redirect: 'noredirect',
    name: 'Statistics',
    meta: {
      title: 'statisticsCenter',
      icon: 'statistics'
    },
    children: [
      {
        path: 'sales-statistics',
        // hidden: true,
        component: _import('statistics/SalesStatistics'),
        name: 'SalesStatistics',
        meta: {
          title: 'salesStatistics'
        }
      },
      {
        path: 'orders-statistics',
        // hidden: true,
        component: _import('statistics/OrdersStatistics'),
        name: 'OrdersStatistics',
        meta: {
          title: 'ordersStatistics'
        }
      },
      {
        path: 'goods-statistics',
        // hidden: true,
        component: _import('statistics/GoodsStatistics'),
        name: 'GoodsStatistics',
        meta: {
          title: 'goodsStatistics'
        }
      },
      {
        path: 'members-statistics',
        // hidden: true,
        component: _import('statistics/MembersStatistics'),
        name: 'MembersStatistics',
        meta: {
          title: 'membersStatistics'
        }
      }
    ]
  },

  // 仓储中心
  {
    path: '/stock',
    component: Layout,
    redirect: 'noredirect',
    name: 'Stock',
    meta: {
      title: 'stockCenter',
      icon: 'stock'
    },
    children: [
      {
        path: 'all',
        component: _import('stock/all'),
        name: 'AllStock',
        meta: {
          title: 'allStock'
        }
      },
      {
        path: 'in',
        component: _import('stock/in'),
        name: 'StockIn',
        meta: {
          title: 'stockIn'
        }
      },
      {
        path: 'out',
        component: _import('stock/out'),
        name: 'StockOut',
        meta: {
          title: 'stockOut'
        }
      }
    ]
  },

  // 物流中心
  {
    path: '/express',
    component: Layout,
    redirect: 'noredirect',
    name: 'Express',
    meta: {
      title: 'expressCenter',
      icon: 'express'
    },
    children: [
      {
        path: 'template',
        component: _import('express/template'),
        name: 'Template',
        meta: {
          title: 'expressTemplateManagement'
        }
      },
      {
        path: 'expresscompany-list',
        component: _import('express/components/ExpressCompanyList'),
        name: 'ExpressCompanyList',
        meta: {
          title: 'expressCompanyList'
        }
      },
      {
        path: 'template/create',
        hidden: true,
        component: _import('express/create'),
        name: 'CreateTemplate',
        meta: {
          title: 'createTemplate'
        }
      },
      {
        path: 'template/edit/:templateId',
        hidden: true,
        component: _import('express/edit'),
        name: 'EditTemplate',
        meta: {
          title: 'editTemplate'
        }
      }
    ]
  },

  // cms中心
  {
    path: '/cms',
    component: Layout,
    redirect: 'noredirect',
    name: 'CMS',
    meta: {
      title: 'cmsCenter',
      icon: 'cms'
    },
    children: [
      {
        path: 'pc/modules',
        hidden: true,
        component: _import('cms/pc/modules'),
        name: 'PcCmsModules',
        meta: {
          title: 'pcCmsModules'
        }
      },
      {
        path: 'pc/pages',
        component: _import('cms/pc/pages'),
        name: 'PcCmsPages',
        meta: {
          title: 'pcCmsPages'
        }
      },
      {
        path: 'pc/adbanner',
        // hidden: true,
        component: _import('cms/pc/adBanner'),
        name: 'PcAdBanner',
        meta: {
          title: 'pcAdBanner'
        }
      },
      {
        path: 'pc/adbanner/create',
        hidden: true,
        component: _import('cms/pc/adBanner/create'),
        name: 'CreateAdBanner',
        meta: {
          title: 'createAdBanner'
        }
      },
      {
        path: 'pc/adbanner/edit/:bannerId',
        hidden: true,
        component: _import('cms/pc/adBanner/edit'),
        name: 'EditAdBanner',
        meta: {
          title: 'editAdBanner'
        }
      },

      {
        path: 'pc/hot-sales',
        // hidden: true,
        component: _import('cms/pc/hotSales'),
        name: 'PcHotSales',
        meta: {
          title: 'pcHotSales'
        }
      },
      {
        path: 'pc/hot-sales/create',
        hidden: true,
        component: _import('cms/pc/hotSales/create'),
        name: 'CreateHotSales',
        meta: {
          title: 'createHotSales'
        }
      },
      {
        path: 'pc/hot-sales/edit/:hotSalesId',
        hidden: true,
        component: _import('cms/pc/hotSales/edit'),
        name: 'EditHotSales',
        meta: {
          title: 'editHotSales'
        }
      },
      {
        path: 'pc/navigate',
        hidden: true,
        component: _import('cms/pc/navigate'),
        name: 'PcNavigate',
        meta: {
          title: 'pcNavigate'
        }
      },
      {
        path: 'pc/navigate/create',
        hidden: true,
        component: _import('cms/pc/navigate/create'),
        name: 'CreateNavigate',
        meta: {
          title: 'createNavigate'
        }
      },
      {
        path: 'pc/navigate/edit/:id',
        hidden: true,
        component: _import('cms/pc/navigate/edit'),
        name: 'EditNavigate',
        meta: {
          title: 'editNavigate'
        }
      },
      {
        path: 'pc/page/edit/:pageId',
        hidden: true,
        component: _import('cms/pc/page/edit'),
        name: 'EditPage',
        meta: {
          title: 'editPage'
        }
      },
      {
        path: 'pc/page/create',
        hidden: true,
        component: _import('cms/pc/page/create'),
        name: 'CreatePage',
        meta: {
          title: 'createPage'
        }
      }
    ]
  },

  // 会员中心
  {
    path: '/member',
    component: Layout,
    redirect: 'noredirect',
    name: 'MemberManager',
    meta: {
      title: 'memberCenter',
      icon: 'member'
    },
    children: [
      {
        path: 'member-list',
        component: _import('member/components/MemberList'),
        name: 'MemberCenter',
        meta: {
          title: 'memberList'
        }
      },
      {
        path: 'discountplanlist',
        component: _import('member/components/DiscountPlanList'),
        name: 'DiscountPlanList',
        meta: {
          title: 'discountPlans'
        }
      },
      {
        path: 'levellist',
        component: _import('member/components/LevelList'),
        name: 'LevelList',
        meta: {
          title: 'levelList'
        }
      },
      {
        path: '',
        hidden: true,
        name: 'Member',
        meta: {
          title: 'memberList',
          icon: 'member'
        }
      }
    ]
  },
  {
    path: '/member/view',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':memberId',
        name: 'MemberView',
        component: _import('member/view'),
        meta: {
          title: 'memberView'
        }
      }
    ]
  },
  // 店员中心
  {
    path: '/assistant',
    component: Layout,
    redirect: 'noredirect',
    name: 'Assistant',
    meta: {
      title: 'assistantCenter',
      icon: 'assistant2'
    },
    children: [
      {
        path: 'assistant-list',
        // hidden: true,
        component: _import('assistant/components/AssistantList'),
        name: 'AssistantList',
        meta: {
          title: 'assistantList'
        }
      },
      {
        path: 'role-list',
        // hidden: true,
        component: _import('assistant/role/RoleList'),
        name: 'RoleList',
        meta: {
          title: 'roleList'
        }
      },
      {
        path: 'writer-list',
        // hidden: true,
        component: _import('assistant/writer/writerList'),
        name: 'WriterList',
        meta: {
          title: 'writerList'
        }
      }
    ]
  },
  // 店员管理
  {
    path: '/assistant/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateAssistant',
        component: _import('assistant/assistant/create'),
        meta: {
          title: 'addAssistant'
        }
      }
    ]
  }
]

// 代理商
export const agentRoutes = [
  {
    path: '/agent',
    component: Layout,
    redirect: 'noredirect',
    name: 'Agent',
    meta: {
      title: 'agent',
      icon: 'agent'
    },
    children: [
      {
        path: 'agent-list',
        component: _import('agent/AgentList'),
        name: 'AgentList',
        meta: {
          title: 'agentList'
        }
      },
      {
        path: 'withdraw-list',
        name: 'WithdrawList',
        component: _import('agent/withdraw/withdrawList'),
        meta: { title: 'WithdrawList' }
      }
    ]
  },
  {
    path: '/withdraw/:applicationId',
    hidden: true,
    component: Layout,
    children: [
      {
        path: '',
        name: 'withdrawDetail',
        component: _import('agent/withdraw/withdrawDetail'),
        meta: {
          title: 'withdrawDetail'
        }
      }
    ]
  },
  {
    path: '/agent/wallet-histroy/:agentId',
    hidden: true,
    component: Layout,
    children: [
      {
        path: '',
        name: 'walletHistory',
        component: _import('agent/digitalWallet/walletHistory'),
        meta: {
          title: 'walletHistory'
        }
      }
    ]
  },
  {
    path: '/agent/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateAgent',
        component: _import('agent/CreateAgent'),
        meta: {
          title: 'createAgent'
        }
      }
    ]
  },
  {
    path: '/agent/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':agentId',
        name: 'EditAgent',
        component: _import('agent/EditAgent'),
        meta: {
          title: 'editAgent'
        }
      }
    ]
  },
  {
    path: '/agent/digital-wallet',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':agentId',
        name: 'DigitalWallet',
        component: _import('agent/DigitalWallet'),
        meta: {
          title: 'digitalWallet'
        }
      }
    ]
  }
]

// 运营中心
export const promotionRoutes = [
  {
    path: '/promotion',
    component: Layout,
    redirect: 'noredirect',
    name: 'Promotion',
    meta: {
      title: 'promotionCenter',
      icon: 'promotion'
    },
    children: [
      {
        path: 'express-fee-promotion-details',
        hidden: true,
        component: _import('promotion/ExpressFeePromotionDetails'),
        name: 'ExpressFeePromotionDetails1',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'express-fee-promotion',
        // hidden: true,
        component: _import('promotion/ExpressFeePromotionList'),
        name: 'FreeExpressFeePromotion',
        meta: {
          title: 'freeExpressFeePromotion'
        }
      },
      {
        path: 'express-fee-promotion-details/create',
        hidden: true,
        component: _import('promotion/expressFee/create'),
        name: 'CreateExpressFeePromotion',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'express-fee-promotion-details/:promotionId',
        hidden: true,
        component: _import('promotion/expressFee/edit'),
        name: 'EditExpressFeePromotion',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'full-reduction-promotion',
        // hidden: true,
        component: _import('promotion/FullReductionPromotion'),
        name: 'FullReductionPromotion',
        meta: {
          title: 'fullReductionPromotion'
        }
      },
      {
        path: 'full-reduction-promotion-details/create',
        hidden: true,
        component: _import('promotion/fullReduction/create'),
        name: 'CreateFullReductionPromotion',
        meta: {
          title: 'fullReductionPromotionDetails'
        }
      },
      {
        path: 'full-reduction-promotion-details/:promotionId',
        hidden: true,
        component: _import('promotion/fullReduction/edit'),
        name: 'EditFullReductionPromotion',
        meta: {
          title: 'fullReductionPromotionDetails'
        }
      },
      {
        path: 'promotion-url',
        // hidden: true,
        component: _import('promotion/promotionUrl'),
        name: 'PromotionUrl',
        meta: {
          title: 'promotionUrl'
        }
      },
      {
        path: 'notice-list',
        component: _import('notice/NoticeList'),
        name: 'NoticeList',
        meta: {
          title: 'noticeList'
        }
      }
      // 会计中心 start
      // {
      //   path: 'transactions',
      //   component: _import('transactions/index'),
      //   name: 'Transactions',
      //   meta: {
      //     title: 'transactionCenter'
      //   }
      // }
      // 会计中心 end
    ]
  }
]

// 运营中心+优惠券
export const promotionAndCouponRoutes = [
  {
    path: '/promotion',
    component: Layout,
    redirect: 'noredirect',
    name: 'Promotion',
    meta: {
      title: 'promotionCenter',
      icon: 'promotion'
    },
    children: [
      {
        path: 'express-fee-promotion-details',
        hidden: true,
        component: _import('promotion/ExpressFeePromotionDetails'),
        name: 'ExpressFeePromotionDetails1',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'express-fee-promotion',
        // hidden: true,
        component: _import('promotion/ExpressFeePromotionList'),
        name: 'FreeExpressFeePromotion',
        meta: {
          title: 'freeExpressFeePromotion'
        }
      },
      {
        path: 'express-fee-promotion-details/create',
        hidden: true,
        component: _import('promotion/expressFee/create'),
        name: 'CreateExpressFeePromotion',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'express-fee-promotion-details/:promotionId',
        hidden: true,
        component: _import('promotion/expressFee/edit'),
        name: 'EditExpressFeePromotion',
        meta: {
          title: 'expressFeePromotionDetails'
        }
      },
      {
        path: 'full-reduction-promotion',
        // hidden: true,
        component: _import('promotion/FullReductionPromotion'),
        name: 'FullReductionPromotion',
        meta: {
          title: 'fullReductionPromotion'
        }
      },
      {
        path: 'full-reduction-promotion-details/create',
        hidden: true,
        component: _import('promotion/fullReduction/create'),
        name: 'CreateFullReductionPromotion',
        meta: {
          title: 'fullReductionPromotionDetails'
        }
      },
      {
        path: 'full-reduction-promotion-details/:promotionId',
        hidden: true,
        component: _import('promotion/fullReduction/edit'),
        name: 'EditFullReductionPromotion',
        meta: {
          title: 'fullReductionPromotionDetails'
        }
      },
      {
        path: 'promotion-url',
        // hidden: true,
        component: _import('promotion/promotionUrl'),
        name: 'PromotionUrl',
        meta: {
          title: 'promotionUrl'
        }
      },
      {
        path: 'notice-list',
        component: _import('notice/NoticeList'),
        name: 'NoticeList',
        meta: {
          title: 'noticeList'
        }
      },
      {
        path: 'coupon-list',
        // hidden: true,
        component: _import('coupon/couponList'),
        name: 'CouponList',
        meta: {
          title: 'couponList'
        }
      }
      // 会计中心 start
      // {
      //   path: 'transactions',
      //   component: _import('transactions/index'),
      //   name: 'Transactions',
      //   meta: {
      //     title: 'transactionCenter'
      //   }
      // }
      // 会计中心 end
    ]
  },
  {
    path: '/coupon/create',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CreateCoupon',
        component: _import('coupon/createCoupon'),
        meta: {
          title: 'createCoupon'
        }
      }
    ]
  },
  {
    path: '/coupon/edit',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':couponId',
        name: 'EditCoupon',
        component: _import('coupon/editCoupon'),
        meta: {
          title: 'editCoupon'
        }
      }
    ]
  },
  {
    path: '/coupon/statistics',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':couponId',
        name: 'CouponStatistics',
        component: _import('coupon/couponStatistics'),
        meta: {
          title: 'couponStatistics'
        }
      }
    ]
  }
]

// 会计中心 start
export const transactionsRoutes = [
  {
    path: '/transactions',
    component: Layout,
    redirect: 'noredirect',
    name: 'Transactions',
    meta: {
      title: 'transactionCenter',
      icon: 'merchandise'
    },
    children: [
      {
        path: 'list',
        component: _import('transactions/index'),
        name: 'TransactionCenter',
        meta: {
          title: 'transactionCenter',
          icon: 'merchandise',
          keepAlive: true
        }
      }
    ]
  }
]
// 会计中心 end

export const bankingSolutions = [
  {
    path: '/banking',
    component: Layout,
    redirect: 'noredirect',
    name: 'Bank',
    meta: {
      title: 'bankingSolutions',
      icon: 'bankcard'
    },
    children: [
      {
        path: 'solutions',
        component: _import('banking/index'),
        name: 'BankingSolutions',
        meta: {
          title: 'bankingSolutions',
          icon: 'bankcard',
          keepAlive: true,
          badge: 'new'
        }
      }
    ]
  }
]

// 店铺管理
export const shopRoutes = [
  {
    path: '/shop',
    component: Layout,
    redirect: 'noredirect',
    name: 'ShopCenter',
    meta: {
      title: 'shopCenter',
      icon: 'shop'
    },
    children: [
      {
        path: 'shop-detail',
        component: _import('shop/components/ShopDetail'),
        name: 'ShopDetail',
        meta: {
          title: 'pcShop',
          badge: 'dot'
        }
      },
      {
        path: 'payment-method-management',
        // hidden: true,
        component: _import('shop/components/PaymentMethodManagement'),
        name: 'PaymentMethodManagement',
        meta: {
          title: 'paymentMethodManagement'
        }
      },
      {
        path: 'notification-management',
        // hidden: true,
        component: _import('shop/components/NotificationManagement'),
        name: 'NotificationManagement',
        meta: {
          title: 'notificationManagement'
        }
      },
      {
        path: 'theme-management',
        component: _import('shop/components/ThemeManagement'),
        name: 'ThemeManagement',
        meta: {
          title: 'themeManagement'
        }
      },
      {
        path: 'theme-management/:themeId',
        hidden: true,
        component: _import('shop/components/ThemeCustomization'),
        name: 'ThemeCustomization',
        meta: {
          title: 'themeCustomization',
          keepAlive: true
        }
      },
      {
        path: 'theme-management/:themeId/create-banner/:groupId',
        hidden: true,
        component: _import('shop/components/CreateBanner'),
        name: 'CreateBanner',
        meta: {
          title: 'createBanner'
        }
      },
      {
        path: 'theme-management/:themeId/edit-banner/:bannerId',
        hidden: true,
        component: _import('shop/components/EditBanner'),
        name: 'EditBanner',
        meta: {
          title: 'editBanner'
        }
      },
      {
        path: '',
        hidden: true,
        name: 'Shop',
        meta: {
          title: 'pcShop',
          icon: 'shop'
        }
      }
    ]
  }
]
